module.exports = __webpack_public_path__ + "static/media/alert-cream.230ef7e1.svg";